import { useNavigate } from 'react-router-dom';
import notificationIcon from '../../../assets/img/notification.svg';
import dashboardIcon2 from '../../../assets/img/dashboardicon.svg';
import rightArrowdown from '../../../assets/img/right-arrow-down.svg';
import bellIcon2 from '../../../assets/img/bell-01.svg';
import kanbanIcon from 'assets/img/khanban-icon.svg';
import calenderIcon2 from '../../../assets/img/calendar-date.svg';
import { useAuth } from 'contexts/AuthContext';
import { useSocket } from './context/SocketContext';
import Tippy from '@tippyjs/react';

/** Project title + edit (used in main header or stacked above tabs) */
export const ProjectBoardTitle = ({
  projectOptions,
  isTemplateActive,
  showSavedTemplates,
  projectDetail,
  hideEditButton,
  projectBoardId,
  title,
  setBoards,
  setBoardTitle,
  projectName,
  isProjectRelatedBoard,
  workSpaceTitle
}) => {
  const socket = useSocket();

  const handleSubmitTitle = async (value) => {
    socket.emit('update-project-board', {
      id: projectBoardId,
      payload: { name: value }
    });
    setBoards((prevState) =>
      prevState.map((state) => {
        if (state._id === projectBoardId) {
          return {
            ...state,
            name: value
          };
        } else return state;
      })
    );
    setBoardTitle(value);
  };

  if (!projectOptions?.length) {
    return null;
  }

  return (
    <h2
      className={`title_project title_project--above-tabs ${
        isTemplateActive ? 'title_project--preview' : ''
      }`}
    >
      {isTemplateActive && (
        <span className="preview-title">Preview:</span>
      )}
      {showSavedTemplates ? (
        'Saved Templates'
      ) : isTemplateActive ? (
        <span className="title_project__wrapper">{projectDetail.name}</span>
      ) : (
        <span className="title_project__wrapper">
          {' '}
          {isProjectRelatedBoard ? projectName : workSpaceTitle}
          {/* <span className="title_project__label">Project Name</span>
          <span className="title_project__dot"> • </span> */}
          {/* <EditableText
            title={title}
            handleSubmitTitle={handleSubmitTitle}
            hideEditButton={hideEditButton}
            defaultEditMode={projectBoardId === 'NEW'}
          /> */}
        </span>
      )}
    </h2>
  );
};

const ProjectBoardToolbar = ({ toggleModal, isUnread, subInfo, isUser1, navigate, projectDetail, userShortName }) => (
  <div className="head-right project-board-header-toolbar">
    <img
      src={dashboardIcon2}
      alt="menu"
      className="feather-img feather-img2 menuicon cursor_pointer hw-27"
      onClick={() => {
        navigate('/');
      }}
    />
    <Tippy content={'Happy Clients'} placement="top" arrow={true}>
      <img
        src={dashboardIcon2}
        alt="menu"
        className="feather-img dark-feather-img2 menuicon cursor_pointer hw-27"
        onClick={() => {
          navigate('/');
        }}
      />
    </Tippy>
    <Tippy content={'Happy Projects'} placement="top" arrow={true}>
      <img
        src={kanbanIcon}
        alt="menu"
        className={`feather-img menuicon cursor_pointer`}
        onClick={() => {
          // if (projectDetail?.projectBoards?.[0].isProjectRelatedBoard) {
          //   navigate(`/overview/${projectDetail?.projectBoards?.[0].projectId}`);
          // } else {
          navigate('/project-boards');
          // }
        }}
      />
    </Tippy>
    {/* <div
      onClick={() =>
        navigate('/project-boards', {
          state: {
            isCalenderView: true
          }
        })
      }> */}
    <Tippy content={'My Calendar'} placement="top" arrow={true}>
      <img
        src={calenderIcon2}
        alt="menu"
        className="feather-img2 menuicon cursor_pointer hw-27"
        onClick={() =>
          navigate('/project-boards', {
            state: {
              isCalenderView: true
            }
          })
        }
      />
    </Tippy>
    {/* </div> */}
    {((subInfo?.isActive && isUser1) || !isUser1) && (
      <div className="notify-drp cursor_pointer" onClick={() => toggleModal('notifications', true)}>
        <Tippy content={'Notifications'} placement="top" arrow={true}>
          {isUnread ? (
            <img src={bellIcon2} alt="comp1" className="notification-img hw-27" />
          ) : (
            <img src={notificationIcon} alt="comp1" className="notification-img hw-27" />
          )}
        </Tippy>
      </div>
    )}
    <a
      className="menuicon-user"
      onClick={() => {
        toggleModal('profileModal', true);
      }}>
      {userShortName}
      <img src={rightArrowdown} alt="menu" className="menuicon2" />
    </a>
  </div>
);

const ProjectBoardHeader = ({
  projectOptions,
  toggleModal,
  showBack,
  isUnread,
  isTemplateActive,
  showSavedTemplates,
  projectDetail,
  hideEditButton,
  projectBoardId,
  boards,
  title,
  setBoards,
  setBoardTitle,
  toolbarOnly = false,
  projectName,
  isProjectRelatedBoard = true,
  workSpaceTitle
}) => {
  const navigate = useNavigate();
  const { subInfo, isUser1, userShortName } = useAuth();

  const toolbar = (
    <ProjectBoardToolbar
      toggleModal={toggleModal}
      isUnread={isUnread}
      subInfo={subInfo}
      isUser1={isUser1}
      navigate={navigate}
      projectDetail={projectDetail}
      userShortName={userShortName}
    />
  );

  if (toolbarOnly) {
    return <div className="project-board-header-toolbarOnly">{toolbar}</div>;
  }

  return (
    <>
      <ProjectBoardTitle
        projectOptions={projectOptions}
        isTemplateActive={isTemplateActive}
        showSavedTemplates={showSavedTemplates}
        projectDetail={projectDetail}
        hideEditButton={hideEditButton}
        projectBoardId={projectBoardId}
        title={title}
        setBoards={setBoards}
        setBoardTitle={setBoardTitle}
        projectName={projectName}
        workSpaceTitle={workSpaceTitle}
        isProjectRelatedBoard={isProjectRelatedBoard}
      />
      {toolbar}
    </>
  );
};

export default ProjectBoardHeader;
